import { contexData } from "@/store";
import React, { useState, useRef, useCallback, useEffect, useContext } from "react";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import PubSub from "pubsub-js";

import Slider from "react-slick";
import "./slick.less";
import styles from "./matrixCard.module.less";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);

export default function CarouselComponent(props) {
  const { dispatch } = useContext(contexData);
  let {
    children,
    info: {
      preferences: {
        childPrefer: { optionForm, fadeOut, pcH5Setting },
      },
    },
    colData,
    callback,
    cardOptionFormEnable = false,
  } = props;
  let crouselRef = useRef();
  const [current, setCurrent] = useState(0);
  const autoplayFn = useCallback(() => {
    if (fadeOut == 2 && current < colData.length) {
      crouselRef.current && crouselRef.current.slickNext();
    }
  }, [current]);

  useEffect(() => {
    const goNext = () => {
      crouselRef.current && crouselRef.current.slickNext();
    };
    const goPrev = () => {
      crouselRef.current && crouselRef.current.slickPrev();
    };
    callback && callback(crouselRef, autoplayFn, current, { goNext, goPrev });
  }, [current]);

  useEffect(() => {
    PubSub.subscribe("noAnswer", (msg, data) => {
      setCurrent(data + 1);
      crouselRef.current && crouselRef.current.slickGoTo(data);
    });
    dispatch({type: 'crouselRef', data: {'crouselRef': crouselRef?.current}})
  }, []);

  const settings = {
    className: "",
    dots: false,
    // infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    beforeChange: (oldIndex, newIndex) => {
      setCurrent((a) => {
        return newIndex;
      });
    },
    ref: crouselRef,
  };
  if (optionForm !== 4 && !cardOptionFormEnable) {
    return children;
  }
  // pcH5Setting: 0 都生效 | 1 只pc生效 | 2 只h5生效
  if (isMobile && pcH5Setting === 1) {
    return children;
  }
  if (!isMobile && pcH5Setting === 2) {
    return children;
  }
  return (
    <>  
        
       <Slider tooltip={{ open: true }} {...settings}>{children}</Slider>
      <div className={styles.switch_but}>
        <div className={styles.left} style={{height:isMobile?'18px':'24px'}}>
          {current !== 0 && (
            <LeftOutlined
              style={{ color: "#3c8dff",fontSize:isMobile?'18px':'24px',stroke:'#3c8dff',strokeWidth:'100px',alignItems:'center' }}
              onClick={() => {
                crouselRef.current.slickPrev();
              }}
            />
          )}
        </div>
        <div>
          {current + 1}/{colData.length}
        </div>
        <div className={styles.right} style={{height:isMobile?'18px':'24px'}}>
          {current + 1 !== colData.length && (
            <RightOutlined
              style={{ color: "#3c8dff",fontSize:isMobile?'18px':'24px',stroke:'#3c8dff',strokeWidth:'100px',alignItems:'center' }}
              onClick={() => {
                crouselRef.current.slickNext();
              }}
            />
          )}
        </div>
      </div>
      <style>
        {
          `.slick-slide img{
            display: inline-block
          }`
        }
      </style>
    </>
  );
}
